var _style, _rect, _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlywireLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 260 140",
    style: {
      enableBackground: "new 0 0 260 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{clip-path:url(#SVGID_00000012455982210672133510000010000131069239545785_);}\n\t.st2{fill:#800000;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2980",
    y: 0,
    className: "st0",
    width: 260,
    height: 140
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8967",
    transform: "translate(963.882 888.494)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -952.8,
    y: -858.7,
    width: 237.9,
    height: 80.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154398809550850352080000011833999094177932450_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8966",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000154398809550850352080000011833999094177932450_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10597",
    className: "st2",
    d: "M-902.6-795.8l10-62.9h8.1l-10,62.9H-902.6z M-853.5-797c-1.9,12.2-8.8,18.7-20,18.7 c-6.9,0-12.1-2.6-15.7-6.9l4.5-5.5c2.7,3.5,6.8,5.4,11.2,5.3c6.7,0,11-3.8,12.1-11.7l0.5-3.1h-0.2c-3.3,3.3-7.7,5.2-12.4,5.3 c-8.6,0-12.9-4.3-12.9-12.7c0-1.7,0.2-3.4,0.5-5l4-25.8h7.9l-4.1,25.8c-0.2,1.2-0.3,2.4-0.2,3.6c0,4.8,2.1,6.9,6.7,6.9 c5,0,9.3-2.9,12.1-8.1l4.3-28.2h8.1L-853.5-797 M-763-830.7l1.7-7.9h-8.1l-6.7,43h8.1l3.6-23c1.7-8.6,7.6-12.7,14.3-12.7h2.1 l1.2-7.7C-753.5-840.1-760.1-836.7-763-830.7 M-793.5-838.3l-13.1,29.7l-4.8-29.7h-7.6l-13.8,29.7l-4.5-29.7h-8.1l6.9,42.8h8.6 l13.3-29.7l4.5,29.7h8.1l19.1-42.8H-793.5 M-790.7-795.5l6.7-42.8h8.1l-6.7,42.8H-790.7 M-773.8-847c0,2.5-2,4.5-4.5,4.5l0,0 c-2.5-0.1-4.6-2-4.8-4.5c0.1-2.5,2.1-4.5,4.5-4.5c2.4-0.2,4.6,1.7,4.8,4.1C-773.8-847.2-773.8-847.1-773.8-847 M-923.1-826.6 l0.7-4.5H-951l1.2-7.4h28.6l0.5-3.6c1.7-10.5,8.6-16.5,19.1-16.5h5.9l-1.2,7.4h-5.2c-5.7,0-9,2.9-10,9.3l-0.5,3.3h11l-1.2,7.4 h-11l-6.2,36.1c-1.7,10.5-8.6,16.5-19.3,16.3h-0.5l1.2-7.9h0.5c6,0,9-2.6,10-8.8l3.8-23.4h-28.6l1.2-7.4h28.6V-826.6z  M-736.4-802L-736.4-802c11.2-0.2,11.4-8.1,11.4-8.1h7.4c0,0-1.7,14.8-19,14.8c-5.2,0-9.8-1.7-12.4-5c-2.9-3.6-3.8-7.9-2.9-13.4 l0.5-3.8c1.7-10,3.8-22.5,21.2-22.5c4.8,0,8.8,1.4,11.4,4.1c2.4,2.2,3.8,5.3,3.8,8.6c0.2,4.3-2,8.3-5.7,10.5 c-3.8,2.4-8.6,2.9-12.1,2.9h-11.7c-0.7,4.1-0.2,7.4,1.4,9.1C-741.5-802.8-739-801.7-736.4-802 M-743-821.6L-743-821.6l-0.2,1.4 h11c6.9,0,10-2.2,10-6.5c0-3.8-3.1-6-8.1-6C-737.3-832.8-741.6-828.8-743-821.6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlywireLight);
export default __webpack_public_path__ + "static/media/flywire_light.a03bbb84323584a41ac1bd855307ff30.svg";
export { ForwardRef as ReactComponent };